import { IdentityUserAri } from '@atlassian/ari';

/**
 * Safely parses a user Ari into a resource ID.
 * Returns null if the user Ari is not valid.
 */
export const safelyParseUserAri = (userAri: string | null | undefined): IdentityUserAri | null => {
	if (!userAri) {
		return null;
	}

	try {
		return IdentityUserAri.parse(userAri);
	} catch {
		return null;
	}
};
